import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GuideApi } from '../../api/guide-api';
import { HighGuideInsights } from '../../models/guide/dto/high-guide-insights';
import { FileSystemService } from '../../services/file-system.service';
import { FetchOptions } from '../base/fetch-strategy';
import { Repository } from '../base/repository';

/**
 * Data-access layer for the HighGuide insight rollup.
 *
 * Location scoped, so the cache is keyed on (companyId, locationId) even though the endpoint takes the location
 * through a header rather than the path. `windowDays` is not part of the key: the dashboard only ever asks for the
 * backend default, and a windowed read would otherwise overwrite the default entry.
 */
@Injectable()
export class InsightsRepository extends Repository {
  constructor(
    fileSystemService: FileSystemService,
    protected guideAPI: GuideApi
  ) {
    super(fileSystemService);
  }

  private readonly insightsDataKey = 'highGuideInsights';

  public getInsights$(
    companyId: number,
    locationId: number,
    windowDays?: number,
    opts?: FetchOptions
  ): Observable<HighGuideInsights | null> {
    return this.loadInstance$(
      HighGuideInsights,
      companyId,
      locationId,
      this.insightsDataKey,
      this.guideAPI.getInsights$(locationId, windowDays),
      opts
    );
  }
}
